import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cc7f0ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card card-feat" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Boka en tid med en rådgivare nedan.", -1))
const _hoisted_6 = { class: "row my-3" }
const _hoisted_7 = { class: "col-sm-6 my-2" }
const _hoisted_8 = { class: "col-sm-6 my-2" }
const _hoisted_9 = { class: "row my-3 text-center" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Vald dag: ")
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Vald tid: ")
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_15 = { class: "row border-top border-light pt-3 text-center" }
const _hoisted_16 = { class: "col-md-6 offset-md-3 my-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Är det något du vill meddela rådgivaren innan den ringer?", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "col-sm-4 col-md-4 d-grid" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Tillbaka till startsidan ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.submitted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Datepicker, {
                    modelValue: _ctx.date,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
                    monthNameFormat: "long",
                    locale: "sv",
                    minDate: _ctx.setMinDate,
                    disabledWeekDays: [6, 0],
                    autoApply: "",
                    inline: "",
                    enableTimePicker: false,
                    disabledDates: _ctx.disableHolidays,
                    maxDate: _ctx.setMaxDate
                  }, null, 8, ["modelValue", "minDate", "disabledDates", "maxDate"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Datepicker, {
                    modelValue: _ctx.time,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.time) = $event)),
                    locale: "sv",
                    timePicker: "",
                    autoApply: true,
                    filters: _ctx.filters,
                    startTime: _ctx.startTime,
                    inline: "",
                    minTime: _ctx.minTime,
                    maxTime: _ctx.maxTime,
                    modeHeight: "275"
                  }, null, 8, ["modelValue", "filters", "startTime", "minTime", "maxTime"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.date)), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatTime(_ctx.time)), 1)
                ])
              ]),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.errorMessage), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.note) = $event)),
                    rows: "4",
                    cols: "50"
                  }, null, 512), [
                    [_vModelText, _ctx.form.note]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                    class: "btn btn-primary mt-3"
                  }, " Boka tid ")
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("strong", null, "Du har en tid inbokad " + _toDisplayString(_ctx.formatDate(_ctx.date)) + " mellan " + _toDisplayString(_ctx.formatCallTime(_ctx.time)) + ". Vi kommer att ringa dig från 08-408 396 93.", 1)
              ])
            ])),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_router_link, {
              to: { name: 'mortgage_index' },
              class: "btn btn-secondary my-2"
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}